import {createSvgIcon} from '../create-svg-icon';

export const SubdirectoryArrowLeftIcon = createSvgIcon(
  <path d="m11 9 1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z" />
, 'SubdirectoryArrowLeftOutlined');
